import { ReactElement } from 'react';
import { Typography } from 'antd';
import type { Honbu } from '../types';
import { HONBU_LABEL } from '../types';

const { Title: AntTitle, Paragraph } = Typography;

interface Props {
  honbu: Honbu;
}

const Title = ({ honbu }: Props): ReactElement => {
  return (
    <>
      <AntTitle level={1}>{HONBU_LABEL[honbu]}用設定</AntTitle>
      <Paragraph type='secondary'>広告コードごとに、自動架電対象の仕事Noと時間帯を設定します。</Paragraph>
    </>
  );
};

export default Title;
